import { apiClient, getAuthHeaders } from './api';

export interface ShipToAddress {
  id: string;
  customer_id: string;
  epicor_ship_to_num: string;
  epicor_customer_id: string;
  name: string;
  address1?: string;
  address2?: string;
  address3?: string;
  city?: string;
  state?: string;
  zip_code?: string;
  country?: string;
  contact_name?: string;
  phone?: string;
  email?: string;
  is_primary: boolean;
  is_active: boolean;
  full_address: string;
  display_name: string;
  last_sync_at?: string;
  created_at: string;
  updated_at: string;
}

export interface ShipToAddressListResponse {
  addresses: ShipToAddress[];
  total: number;
  primary_address?: ShipToAddress;
}

export interface ShipToAddressUpdate {
  name?: string;
  contact_name?: string;
  phone?: string;
  email?: string;
  is_primary?: boolean;
}

export const shipToAddressService = {
  /**
   * Get all ship-to addresses for the current customer
   */
  async getShipToAddresses(activeOnly: boolean = true): Promise<ShipToAddressListResponse> {
    const params = new URLSearchParams();
    if (activeOnly) {
      params.append('active_only', 'true');
    }
    
    const headers = getAuthHeaders();
    const response = await apiClient.get<ShipToAddressListResponse>(
      `/ship-to-addresses?${params.toString()}`, headers
    );
    return response;
  },

  /**
   * Get a specific ship-to address by ID
   */
  async getShipToAddress(addressId: string): Promise<ShipToAddress> {
    const headers = getAuthHeaders();
    const response = await apiClient.get<ShipToAddress>(`/ship-to-addresses/${addressId}`, headers);
    return response;
  },

  /**
   * Update a ship-to address (limited fields)
   */
  async updateShipToAddress(addressId: string, updates: ShipToAddressUpdate): Promise<ShipToAddress> {
    const headers = getAuthHeaders();
    const response = await apiClient.put<ShipToAddress>(`/ship-to-addresses/${addressId}`, updates, headers);
    return response;
  },

  /**
   * Set a ship-to address as primary
   */
  async setPrimaryAddress(addressId: string): Promise<ShipToAddress> {
    const headers = getAuthHeaders();
    const response = await apiClient.post<ShipToAddress>(`/ship-to-addresses/${addressId}/set-primary`, {}, headers);
    return response;
  }
};